import { createStyles, makeStyles } from '@material-ui/styles';
import { grey } from '../../../theme/colors';

const style = () =>
  createStyles({
    root: {
      padding: '20px',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      marginBottom: '80px'
    },
    logout: {
      marginBottom: '20px'
    },
    headintro: {
      display: 'flex',
      gap: '5px',
      flexWrap: 'wrap',
      fontWeight: 600,
      fontSize: '1.5rem'
    },
    actionboxintro: {
      display: 'flex',
      flexDirection: 'column',
      textAlign: 'center',
      gap: '7px'
    },
    dashblock: {
      border: '1px dashed #000000',
      padding: '10px',
      borderRadius: '10px',
      width: '100%',
      maxWidth: '375px',
      display: 'flex',
      flexDirection: 'column',
      marginLeft: 'auto',
      marginRight: 'auto',
      transition: 'ease-out all 0.3s .1s',
      '&:hover': {
        paddingRight: '20px',
        paddingLeft: '20px',
        maxWidth: '395px'
      }
    },
    headprofil: {
      display: 'flex',
      flexDirection: 'column',
      gap: '10px',
      alignItems: 'center'
    },
    completeactions: {
      display: 'flex',
      gap: '20px',
      justifyContent: 'center',
      flexWrap: 'wrap',
      margin: '5px 0 5px 0'
    },
    action: {
      display: 'flex',
      gap: '5px',
      justifyContent: 'center',
      alignItems: 'center'
    },
    emojiImage: {
      width: '32px',
      height: '32px'
    },
    modalContent: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      gap: '10px',
      padding: '20px'
    },
    modalList: {
      width: '90%'
    },
    textContrast: {
      color: grey.dark
    }
  });

const useStyle = makeStyles(style);
export default useStyle;
